import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cb5a8b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cameras_head" }
const _hoisted_2 = { class: "btns" }
const _hoisted_3 = { class: "tag_btn_wrap" }
const _hoisted_4 = {
  key: 0,
  class: "all_checkbox"
}
const _hoisted_5 = { class: "tag_btn" }
const _hoisted_6 = { class: "tag_setting_btn" }
const _hoisted_7 = { class: "multi_buttons" }

import IconButton from '@/components/molecules/IconButton'
import SimpleCheckbox from '@/components/atoms/SimpleCheckbox'
import MultiButtons from '@/components/molecules/MultiButtons'
import SimpleButton from '@/components/atoms/SimpleButton'
import i18n from '@/plugins/i18n'
import { computed, withDefaults } from 'vue'

type PropsType = {
  isLoaded: boolean
  checkedAll: boolean
  displayCheckBox: boolean
  displayTagSettingBtn: boolean
  selectedTabName: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraListHeader',
  props: {
    isLoaded: { type: Boolean, default: false },
    checkedAll: { type: Boolean, default: false },
    displayCheckBox: { type: Boolean, default: false },
    displayTagSettingBtn: { type: Boolean, default: false },
    selectedTabName: { default: 'list' }
  },
  emits: ["update:checkedAll", "change", "toggleTagBtn", "toggleTagSettingDialog", "selectCamera", "selectTab"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:checkedAll', checkedAll: boolean): void
  (e: 'change'): void
  (e: 'toggleTagBtn'): void
  (e: 'toggleTagSettingDialog'): void
  (e: 'selectCamera'): void
  (e: 'selectTab', view: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLoaded: boolean, checkedAll: boolean, displayCheckBox: boolean, displayTagSettingBtn: boolean, selectedTabName: string };





const multiButtonsOptions = [
  {
    icon: 'view_headline',
    text: i18n.global.t('camera_list_header.list_display'),
    tabName: 'list',
  },
  {
    icon: 'view_module',
    text: i18n.global.t('camera_list_header.grid_display'),
    tabName: 'tile',
  },
  {
    icon: 'place',
    text: i18n.global.t('camera_list_header.map_display'),
    tabName: 'map',
  },
  {
    icon: 'view_quilt',
    text: i18n.global.t('camera_list_header.multi_video'),
    tabName: 'multi',
    className: 'sm_hide', // スマホではマルチ映像は非表示
  },
]

const checked = computed({
  get: () => props.checkedAll,
  set: (v) => {
    emit('update:checkedAll', v)
  },
})

const settingColor = computed<string>(() =>
  props.displayTagSettingBtn ? 'bg-color-primary-grd ' : 'color-primary'
)

const selectTab = (tabName: string) => {
  // マップ表示の場合
  if (tabName === 'map') {
    emit('selectCamera')
  }
  emit('selectTab', tabName)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.displayCheckBox)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(SimpleCheckbox), {
                modelValue: _unref(checked),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : null)),
                disabled: !__props.isLoaded,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change'))),
                "data-test": "cameras-head-tag-setting-checkbox"
              }, null, 8, ["modelValue", "disabled"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(IconButton), {
            icon: "label",
            "icon-color": "color-dark2",
            "use-border": false,
            disabled: __props.selectedTabName !== 'list',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleTagBtn'))),
            "data-test": "cameras-head-tag-toggle-button"
          }, null, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(SimpleButton), {
            color: _unref(settingColor),
            size: "size-s",
            useBorder: true,
            disabled: !__props.isLoaded,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggleTagSettingDialog'))),
            "data-test": "cameras-head-tag-toggle-setting-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('camera_list_header.setting')), 1)
            ]),
            _: 1
          }, 8, ["color", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(MultiButtons), {
          selectTabName: __props.selectedTabName,
          options: multiButtonsOptions,
          onSelect: selectTab
        }, null, 8, ["selectTabName"])
      ])
    ])
  ]))
}
}

})